import { generatePath } from "@routes/utils";

const pathBase = `/auth/token/refresh/`;

export const refresh = {
  post: () => generatePath(pathBase, null),
};
